/**
 * Convert a canonical UUID string (with or without hyphens) into its 16-byte
 * big-endian representation.
 *
 * We need this because Rust's `Uuid::as_bytes()` yields the same 16-byte
 * layout, and the alerts pipeline binds those raw bytes into the AEAD AAD
 * (see `crates/backstop-core/src/e2ee_ops::encrypt_alert_body`).
 */
export function uuidToBytes(uuid: string): Uint8Array {
  const hex = uuid.replace(/-/g, '');
  if (hex.length !== 32) {
    throw new Error(`invalid uuid: ${uuid}`);
  }
  const out = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    const byte = Number.parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    if (Number.isNaN(byte)) {
      throw new Error(`invalid uuid: ${uuid}`);
    }
    out[i] = byte;
  }
  return out;
}
